import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'Continue',
    description:
      'Compte tenu des informations que vous avez renseignées, nous avons besoin des documents suivants pour compléter votre dossier.',
    title: 'Documents pour l’administration',
  },
  fr: {
    cta: 'Continuer',
    description:
      'Compte tenu des informations que vous avez renseignées, nous avons besoin des documents suivants pour compléter votre dossier.',
    title: 'Documents pour l’administration',
  },
} as const);
